export const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

export const lerp = (start, end, progress) => start + (end - start) * progress;

export const randomBetween = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);

export const normaliseCursorSpeed = (speed, minimum = 40, maximum = 1500) => {
  if (!Number.isFinite(speed) || maximum <= minimum) return 0;
  return clamp((speed - minimum) / (maximum - minimum), 0, 1);
};

/**
 * Screen Y coordinates increase downwards. A small dead zone prevents tiny,
 * nearly-horizontal hand movements from rapidly swapping candle colours.
 */
export const getVerticalDirection = (deltaY, previousDirection = 'up', deadZone = 0.75) => {
  if (deltaY < -deadZone) return 'up';
  if (deltaY > deadZone) return 'down';
  return previousDirection;
};

